import { Subject, Subscription, firstValueFrom } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';
import { BaseDataApiService } from 'src/app/data-transfer/services/base-data-api-service';
import { CreditsDto} from '../data-transfer/entities/credits-dto';

const CREDITS_THRESHOLD_RUNNING_LOW = 50;

@Injectable({ providedIn: 'root' })
export class CreditsService implements OnDestroy {

  creditsCount = new CreditsDto;
  creditsCountChange: Subject<CreditsDto> = new Subject<CreditsDto>();

  private subscription: Subscription;

  constructor(private baseDataApiService: BaseDataApiService) {
    this.subscription = this.creditsCountChange.subscribe((value) => {
      this.creditsCount = value;
    });
  }

  async setCreditsCount() {
    const credits = await this.getCredits();
    this.creditsCountChange.next(credits);
  }

  private async getCredits() {
    return await firstValueFrom(this.baseDataApiService.getCreditsCount());
  }

  // this function returns true if all credit scores are infinite
  areCreditsInfinite() {
    return this.areLcaCreditsInfinite() && this.areRycyclingCreditsInfinite();
  }

  areLcaCreditsInfinite() {
    return this.creditsCount.lcaCredits >= 1000000000;
  }

  areRycyclingCreditsInfinite() {
    return this.creditsCount.recyclabilityCredits >= 1000000000;
  }

  // this function returns true if at least one credit score is running low
  areCreditsRunningLow() {
    return this.areLcaCreditsRunningLow() || this.areRecyclabilityCreditsRunningLow();
  }

  areLcaCreditsRunningLow() {
    return this.creditsCount.lcaCredits <= CREDITS_THRESHOLD_RUNNING_LOW;
  }
  areRecyclabilityCreditsRunningLow() {
    return this.creditsCount.recyclabilityCredits <= CREDITS_THRESHOLD_RUNNING_LOW;
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
